import { getInputFields } from "./formAnswerDisplay";
export function createEmptyFieldFilters(definition) {
    const filters = {};
    getInputFields(definition).forEach((field) => {
        if (field.id)
            filters[field.id] = "";
    });
    return filters;
}
export function isAnswerEmpty(value) {
    if (value === null || value === undefined || value === "")
        return true;
    if (Array.isArray(value) && value.length === 0)
        return true;
    return false;
}
export function isTextLikeField(type) {
    return ["short_text", "long_text", "email", "number", "date"].includes(type);
}
export function isChoiceField(type) {
    return ["single_choice", "multi_choice", "dropdown"].includes(type);
}
export function matchesFieldFilter(field, answer, filterValue) {
    if (!filterValue)
        return true;
    const type = String(field.type);
    const empty = isAnswerEmpty(answer);
    if (filterValue === "empty")
        return empty;
    if (filterValue === "filled")
        return !empty;
    if (type === "rating") {
        if (empty)
            return false;
        return String(Math.round(Number(answer))) === filterValue;
    }
    if (type === "multi_choice") {
        if (empty)
            return false;
        const values = Array.isArray(answer) ? answer.map(String) : [String(answer)];
        return values.includes(filterValue);
    }
    if (isChoiceField(type)) {
        if (empty)
            return false;
        return String(answer) === filterValue;
    }
    return true;
}
export function matchesAllFieldFilters(row, fields, filters) {
    const answers = row.answers || {};
    return fields.every((field) => {
        const filterValue = filters[field.id] || "";
        if (!filterValue)
            return true;
        return matchesFieldFilter(field, answers[field.id], filterValue);
    });
}
export function filterOptionsForField(field) {
    const type = String(field.type);
    const options = [
        { value: "", label: "Tất cả" },
    ];
    if (isTextLikeField(type) || type === "rating") {
        options.push({ value: "filled", label: "Có nội dung" });
        options.push({ value: "empty", label: "Trống" });
    }
    if (type === "rating") {
        const max = field.max || 5;
        for (let star = max; star >= 1; star -= 1) {
            options.push({ value: String(star), label: `${star} sao` });
        }
        return options;
    }
    if (isChoiceField(type)) {
        options.push({ value: "empty", label: "Trống" });
        (field.options || []).forEach((opt) => {
            options.push({ value: String(opt.id), label: opt.label });
        });
        return options;
    }
    return options;
}
